import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
import { Card } from '../components/ui/Card';
import { useAuthStore } from '../store/authStore'; 
import { useTokenInterceptor } from '../hooks/useTokenInterceptor';

export const LoginPage: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [needsReauth, setNeedsReauth] = useState(false);
  const { login, isLoading, error } = useAuthStore();
  const navigate = useNavigate();
  const {checkRedirectUrl, clearRedirectUrl} = useTokenInterceptor();

  useEffect(() => {
    // Check if user was redirected due to authorization issues
    const redirectUrl = checkRedirectUrl();
    if (redirectUrl) {
      setNeedsReauth(true);
    }
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await login(email, password);
      clearRedirectUrl(); 
      navigate('/dashboard');      
    } catch (error) {
      navigate('/login', { state: { error: 'Falha ao entrar. Verifique suas credenciais.' } });
    }
  };

  return (
    <div className="max-w-md mx-auto mt-10 p-6">
      <Card>
        <div className="space-y-6">
          <div className="text-center">
            <h1 className="text-2xl font-bold text-gray-900">Entrar na sua conta</h1>
            <p className="text-gray-600">
              Acesse sua avaliação de perfil de comunicação
            </p>
          </div>

          {needsReauth && (
            <div className="p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
              <p className="text-sm text-yellow-800">
                🔐 Sua sessão expirou ou não é válida. Faça login novamente para continuar onde parou.
              </p>
            </div>
          )}

          {error && (
            <div className="p-4 bg-red-50 border border-red-200 rounded-lg">
              <p className="text-sm text-red-600">{error}</p>
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-4">
            <Input
              label="Email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="seu@email.com"
              required
            />

            <Input
              label="Senha"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Sua senha"
              required
            />

            <Button
              variant="primary"
              type="submit"
              className="w-full py-3"
              loading={isLoading}
              disabled={!email || !password}
            >
              Entrar
            </Button>
          </form>

          <div className="text-center space-y-2">
            <p className="text-sm text-gray-600">
              Não tem uma conta?{' '}
              <Link to="/register" className="text-primary-600 hover:text-primary-700 font-medium">
                Cadastre-se grátis
              </Link>
            </p>
            <Link to="/" className="text-sm text-gray-500 hover:text-gray-700">
              ← Voltar ao início
            </Link>
          </div>
        </div>
      </Card>
    </div>
  );
};